export interface Country {
  code: string;
  name: string;
  dialCode: string;
  flag: string;
  format?: string;
}

export const countries: Country[] = [
  { code: 'US', name: 'United States', dialCode: '+1', flag: '🇺🇸', format: '(XXX) XXX-XXXX' },
  { code: 'CA', name: 'Canada', dialCode: '+1', flag: '🇨🇦', format: '(XXX) XXX-XXXX' },
  { code: 'GB', name: 'United Kingdom', dialCode: '+44', flag: '🇬🇧', format: 'XXXX XXX XXXX' },
  { code: 'AU', name: 'Australia', dialCode: '+61', flag: '🇦🇺', format: 'XXXX XXX XXX' },
  { code: 'DE', name: 'Germany', dialCode: '+49', flag: '🇩🇪', format: 'XXX XXXXXXX' },
  { code: 'FR', name: 'France', dialCode: '+33', flag: '🇫🇷', format: 'XX XX XX XX XX' },
  { code: 'IT', name: 'Italy', dialCode: '+39', flag: '🇮🇹', format: 'XXX XXX XXXX' },
  { code: 'ES', name: 'Spain', dialCode: '+34', flag: '🇪🇸', format: 'XXX XX XX XX' },
  { code: 'NL', name: 'Netherlands', dialCode: '+31', flag: '🇳🇱', format: 'XX XXX XXXX' },
  { code: 'BE', name: 'Belgium', dialCode: '+32', flag: '🇧🇪', format: 'XXX XX XX XX' },
  { code: 'CH', name: 'Switzerland', dialCode: '+41', flag: '🇨🇭', format: 'XX XXX XX XX' },
  { code: 'AT', name: 'Austria', dialCode: '+43', flag: '🇦🇹', format: 'XXX XXXXXXX' },
  { code: 'SE', name: 'Sweden', dialCode: '+46', flag: '🇸🇪', format: 'XX XXX XX XX' },
  { code: 'NO', name: 'Norway', dialCode: '+47', flag: '🇳🇴', format: 'XXX XX XXX' },
  { code: 'DK', name: 'Denmark', dialCode: '+45', flag: '🇩🇰', format: 'XX XX XX XX' },
  { code: 'FI', name: 'Finland', dialCode: '+358', flag: '🇫🇮', format: 'XX XXX XXXX' },
  { code: 'IE', name: 'Ireland', dialCode: '+353', flag: '🇮🇪', format: 'XX XXX XXXX' },
  { code: 'PT', name: 'Portugal', dialCode: '+351', flag: '🇵🇹', format: 'XXX XXX XXX' },
  { code: 'GR', name: 'Greece', dialCode: '+30', flag: '🇬🇷', format: 'XXX XXX XXXX' },
  { code: 'PL', name: 'Poland', dialCode: '+48', flag: '🇵🇱', format: 'XXX XXX XXX' },
  { code: 'CZ', name: 'Czech Republic', dialCode: '+420', flag: '🇨🇿', format: 'XXX XXX XXX' },
  { code: 'HU', name: 'Hungary', dialCode: '+36', flag: '🇭🇺', format: 'XX XXX XXXX' },
  { code: 'RO', name: 'Romania', dialCode: '+40', flag: '🇷🇴', format: 'XXX XXX XXX' },
  { code: 'BG', name: 'Bulgaria', dialCode: '+359', flag: '🇧🇬', format: 'XX XXX XXXX' },
  { code: 'HR', name: 'Croatia', dialCode: '+385', flag: '🇭🇷', format: 'XX XXX XXXX' },
  { code: 'SI', name: 'Slovenia', dialCode: '+386', flag: '🇸🇮', format: 'XX XXX XXX' },
  { code: 'SK', name: 'Slovakia', dialCode: '+421', flag: '🇸🇰', format: 'XXX XXX XXX' },
  { code: 'LT', name: 'Lithuania', dialCode: '+370', flag: '🇱🇹', format: 'XXX XXXXX' },
  { code: 'LV', name: 'Latvia', dialCode: '+371', flag: '🇱🇻', format: 'XX XXX XXX' },
  { code: 'EE', name: 'Estonia', dialCode: '+372', flag: '🇪🇪', format: 'XXX XXXX' },
  { code: 'IS', name: 'Iceland', dialCode: '+354', flag: '🇮🇸', format: 'XXX XXXX' },
  { code: 'MT', name: 'Malta', dialCode: '+356', flag: '🇲🇹', format: 'XXXX XXXX' },
  { code: 'JP', name: 'Japan', dialCode: '+81', flag: '🇯🇵', format: 'XX XXXX XXXX' },
  { code: 'KR', name: 'South Korea', dialCode: '+82', flag: '🇰🇷', format: 'XX XXXX XXXX' },
  { code: 'CN', name: 'China', dialCode: '+86', flag: '🇨🇳', format: 'XXX XXXX XXXX' },
  { code: 'IN', name: 'India', dialCode: '+91', flag: '🇮🇳', format: 'XXXXX XXXXX' },
  { code: 'BR', name: 'Brazil', dialCode: '+55', flag: '🇧🇷', format: 'XX XXXXX XXXX' },
  { code: 'MX', name: 'Mexico', dialCode: '+52', flag: '🇲🇽', format: 'XX XXXX XXXX' },
  { code: 'AR', name: 'Argentina', dialCode: '+54', flag: '🇦🇷', format: 'XX XXXX XXXX' },
  { code: 'CL', name: 'Chile', dialCode: '+56', flag: '🇨🇱', format: 'X XXXX XXXX' },
  { code: 'CO', name: 'Colombia', dialCode: '+57', flag: '🇨🇴', format: 'XXX XXX XXXX' },
  { code: 'PE', name: 'Peru', dialCode: '+51', flag: '🇵🇪', format: 'XXX XXX XXX' },
  { code: 'VE', name: 'Venezuela', dialCode: '+58', flag: '🇻🇪', format: 'XXX XXX XXXX' },
  { code: 'UY', name: 'Uruguay', dialCode: '+598', flag: '🇺🇾', format: 'XXXX XXXX' },
  { code: 'PY', name: 'Paraguay', dialCode: '+595', flag: '🇵🇾', format: 'XXX XXX XXX' },
  { code: 'BO', name: 'Bolivia', dialCode: '+591', flag: '🇧🇴', format: 'XXXX XXXX' },
  { code: 'EC', name: 'Ecuador', dialCode: '+593', flag: '🇪🇨', format: 'XX XXX XXXX' },
  { code: 'GY', name: 'Guyana', dialCode: '+592', flag: '🇬🇾', format: 'XXX XXXX' },
  { code: 'SR', name: 'Suriname', dialCode: '+597', flag: '🇸🇷', format: 'XXX XXXX' },
  { code: 'ZA', name: 'South Africa', dialCode: '+27', flag: '🇿🇦', format: 'XX XXX XXXX' },
  { code: 'EG', name: 'Egypt', dialCode: '+20', flag: '🇪🇬', format: 'XX XXXX XXXX' },
  { code: 'NG', name: 'Nigeria', dialCode: '+234', flag: '🇳🇬', format: 'XXX XXX XXXX' }
];

export const getCountryByCode = (code: string): Country | undefined => {
  return countries.find(country => country.code === code);
};

export const getCountryByDialCode = (dialCode: string): Country | undefined => {
  return countries.find(country => country.dialCode === dialCode);
};

export const formatPhoneNumber = (phone: string, format?: string): string => {
  if (!format) return phone;
  
  const digits = phone.replace(/\D/g, '');
  let formatted = format;
  
  for (let i = 0; i < digits.length; i++) {
    formatted = formatted.replace('X', digits[i]);
  }
  
  return formatted.replace(/X/g, '');
};